module.exports = __webpack_public_path__ + "img/3_5_1.9f1d3c6c.jpg";